import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { createFormulaEntry } from '../api/formula-library.api';
import { FORMULA_ENTRIES_QUERY_KEY } from '../constants/reports-query-keys';

export const useCreateFormulaEntry = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (body: {
      scope: 'USER' | 'ORG';
      key: string;
      label: string;
      formulaString: string;
      dependsOn: string[];
      measureType: string;
    }) => createFormulaEntry(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMULA_ENTRIES_QUERY_KEY });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.formulaCreateError'
      );
    },
  });
};
